import React, { createContext, useContext, useState, useCallback } from "react";
import BookingDialog from "@/components/BookingDialog";

const BookingContext = createContext({ open: () => {} });

export const useBooking = () => useContext(BookingContext);

export function BookingProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [preset, setPreset] = useState(undefined);

  const open = useCallback((service) => {
    setPreset(service);
    setIsOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ open }}>
      {children}
      <BookingDialog open={isOpen} onOpenChange={setIsOpen} presetService={preset} />
    </BookingContext.Provider>
  );
}
